import React from "react";
import { Organisation, User } from "../../../types";
import TeamsTable from "./teams-table";

interface TeamsTableViewProps {
  filteredTeams: Organisation[];
  unfilteredTeamsCount: number;
  users: Record<string, User>;
  canEditOrgs: string[];
}

const TeamsTableView: React.FC<TeamsTableViewProps> = ({
  filteredTeams,
  unfilteredTeamsCount,
  users,
  canEditOrgs,
}) => {
  return (
    <TeamsTable
      filteredTeams={filteredTeams}
      unfilteredTeamsCount={unfilteredTeamsCount}
      users={users}
      canEditOrgs={canEditOrgs}
    />
  );
};

export default TeamsTableView;
